export const skillsData = {
  languages: [
    "JavaScript",
    "TypeScript",
    "HTML5",
    "Vue.js (2.x, 3.x)",
    "React",
    "Next.js",
    "ApostropheCMS, WordPress",
    "Pinia, Vuex, React Context, Redux",
    "TanStack Query, Axios",
  ],
  styles: [
    "CSS3, SASS",
    "Tailwind",
    "ShadCN",
    "Chakra UI",
    "UIkit",
    "Bootstrap",
    "Responsive web design"
  ],
  tools: [
    "Vite, Webpack",
    "Vitest, Playwright",
    "Storybook",
    "Sentry, Lighthouse",
    "ESLint, Prettier",
    "Git, Bitbucket",
    "Jira, Scrum",
    "Claude Code, ChatGPT"
  ]
}
